import './index.css';

import * as moment from 'moment';
import * as React from 'react';
import Member from 'src/entities/Member';
import Memo from 'src/entities/Memo';

import Constants from '../../common/Constants';
import Utility from '../../common/Utility';
import CancelWhite from '../../res/img/cancel_white.svg';
import OtherActionsIcon from '../../res/img/other_actions.svg';

interface IProps {
  account: Member;
  memos: Memo[];
  members: Member[];
  updateMemos: (memos: Memo[]) => void;
}

interface IState {
  otherActionsShown: boolean;
  doesShowChangeDeadlineAll: boolean;
  checkedMemos: number[];
  newDeadline: number;
  progressBarDisplayed: boolean;
}

class ItemComponent extends React.Component<IProps, IState> {
  editDeadline: HTMLInputElement;

  constructor(props: any) {
    super(props);
    this.state = {
      otherActionsShown: false,
      doesShowChangeDeadlineAll: false,
      checkedMemos: [],
      newDeadline: Date.now(),
      progressBarDisplayed: false
    };

    this.toggleOtherActions = this.toggleOtherActions.bind(this);
    this.exportMemos = this.exportMemos.bind(this);
    this.toggleChangeDeadlineAll = this.toggleChangeDeadlineAll.bind(this);
    this.hide = this.hide.bind(this);
    this.onChangeItemDeadline = this.onChangeItemDeadline.bind(this);
    this.updateAllMemos = this.updateAllMemos.bind(this);
    this.onChangeIsListedAll = this.onChangeIsListedAll.bind(this);
  }

  render() {
    const countAllInCheckedMemos = this.state.checkedMemos.length;
    const countDoneInCheckedMemos = this.props.memos
      .filter(m => this.state.checkedMemos.includes(m.id))
      .filter((m: Memo) =>
        moment(m.deadline).isSame(this.state.newDeadline, 'day')
      ).length;

    const ratioInProgress =
      countDoneInCheckedMemos === 0
        ? 0
        : (100 * countDoneInCheckedMemos) / countAllInCheckedMemos;

    if (this.state.progressBarDisplayed === true && ratioInProgress === 100) {
      this.setState({
        progressBarDisplayed: false
      });
    }

    return (
      <div>
        <button
          id="OtherActions"
          onClick={this.toggleOtherActions}
          onBlur={this.hide}
        >
          <img src={OtherActionsIcon} />

          {this.state.otherActionsShown ? (
            <div className="Actions">
              {this.props.account.isSystemAdmin ? (
                <div className="Action" onClick={this.toggleChangeDeadlineAll}>
                  期限の一括変更
                </div>
              ) : null}
              <div className="Action" onClick={this.exportMemos}>
                CSVで出力
              </div>
            </div>
          ) : null}
        </button>
        {this.state.doesShowChangeDeadlineAll ? (
          <div id="ChangeDeadlineAll">
            <div className="Header">
              <span>期限の一括変更</span>
              <img src={CancelWhite} onClick={this.toggleChangeDeadlineAll} />
            </div>
            <div className="MemoItems">
              <div className="MemoItemOtherAction">
                <div className="Check">
                  <input
                    type="checkbox"
                    checked={
                      this.props.memos.length === this.state.checkedMemos.length
                    }
                    onClick={this.onChangeIsListedAll}
                  />
                </div>
                <div className="Memo">メモ</div>
                <div className="Deadline">期限</div>
              </div>

              {this.props.memos
                .filter((m: Memo) => m.reportStatus !== Constants.REPORT_FINAL)
                .map(m => (
                  <div className="MemoItemOtherAction">
                    <div
                      className="Check"
                      onClick={this.onChangeIsListed.bind(this, m.id)}
                    >
                      <input
                        type="checkbox"
                        checked={this.state.checkedMemos.includes(m.id)}
                      />
                    </div>
                    <div className="Memo">
                      <div className="Tags">
                        {m.tags.map(tag => (
                          <div key={tag} className="Tag">
                            #{tag}
                          </div>
                        ))}
                      </div>
                      <div>{m.memo}</div>
                    </div>
                    <div className="Deadline">
                      {m.deadline <= 0 ? (
                        <span>---</span>
                      ) : (
                        <span>
                          {Utility.dateFormat(new Date(m.deadline), 'M/d')}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
            </div>
            <div id="ChangeDeadline">
              <button onClick={this.updateAllMemos}>一括変更</button>

              <input
                type="date"
                value={Utility.dateFormat(
                  new Date(this.state.newDeadline),
                  'yyyy-MM-dd'
                )}
                onChange={this.onChangeItemDeadline}
                ref={deadline => {
                  this.editDeadline = deadline as HTMLInputElement;
                }}
              />
              {this.state.progressBarDisplayed ? (
                <div id="ProgressBar">
                  <div
                    id="ProgressDone"
                    style={{ width: ratioInProgress + '%' }}
                  />
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  toggleOtherActions(e: any) {
    this.setState({
      otherActionsShown: !this.state.otherActionsShown
    });
  }

  hide(e: any) {
    this.setState({
      otherActionsShown: false
    });
  }

  exportMemos() {
    let data = 'ID,メモ,報告責任者,実行責任者,作成日,次の報告日\n';

    this.props.memos.forEach(memo => {
      data +=
        memo.id +
        ',' +
        memo.memo.replace(/\r?\n/g, '') +
        ',' +
        memo.reporters
          .map(
            reporter =>
              (this.props.members.find(
                member => member.id === reporter
              ) as Member).nameLast
          )
          .join('|') +
        ',' +
        memo.performers
          .map(
            reporter =>
              (this.props.members.find(
                member => member.id === reporter
              ) as Member).nameLast
          )
          .join('|') +
        ',' +
        Utility.dateFormat(new Date(memo.created), 'MM/dd') +
        ',' +
        Utility.dateFormat(new Date(memo.deadline), 'MM/dd') +
        '\n';
      memo.comments
        .sort((a, b) => (a.created < b.created ? 1 : -1))
        .forEach(comment => {
          data +=
            ',' +
            comment.text.replace(/\r?\n/g, '') +
            ',' +
            (this.props.members.find(
              member => member.id === comment.memberId
            ) as Member).nameLast +
            ',' +
            Utility.dateFormat(new Date(comment.created), 'MM/dd') +
            ',\n';
        });
    });

    const anchor: any = document.createElement('a');
    if (window.URL && anchor.download !== undefined) {
      // utf8
      const bom = '\uFEFF';
      const blob = new Blob([bom, data], { type: 'text/csv' });
      anchor.download = 'memos';

      anchor.href = window.URL.createObjectURL(blob);
      document.body.appendChild(anchor);
      anchor.click();
      anchor.parentNode.removeChild(anchor);
    }
  }

  toggleChangeDeadlineAll() {
    if (!this.state.doesShowChangeDeadlineAll) {
      this.setState({
        doesShowChangeDeadlineAll: true,
        checkedMemos: this.props.memos
          .filter((m: Memo) => m.reportStatus !== Constants.REPORT_FINAL)
          .map((m: Memo) => m.id)
      });
    } else {
      this.setState({
        doesShowChangeDeadlineAll: false
      });
    }
  }

  onChangeIsListed(memoId: number) {
    if (this.state.checkedMemos.includes(memoId)) {
      this.setState({
        checkedMemos: this.state.checkedMemos.filter(m => m !== memoId)
      });
    } else {
      this.setState({
        checkedMemos: [...this.state.checkedMemos, memoId]
      });
    }
  }

  onChangeItemDeadline(e: any) {
    this.setState({
      newDeadline: 1000 * moment(e.target.value).unix()
    });
  }

  updateAllMemos() {
    if (confirm('期限を一括で変更します')) {
      const updatedMemos: Memo[] = [];
      this.props.memos
        .filter(m => this.state.checkedMemos.includes(m.id))
        .map(m => {
          const memo = Object.assign({}, m);
          memo.deadline = this.state.newDeadline;
          updatedMemos.push(memo);
        });
      this.props.updateMemos(updatedMemos);
      this.setState({
        progressBarDisplayed: true
      });
    }
  }
  onChangeIsListedAll() {
    if (this.state.checkedMemos.length !== 0) {
      this.setState({
        checkedMemos: []
      });
    } else {
      this.setState({
        checkedMemos: this.props.memos.map(m => m.id)
      });
    }
  }
}

export default ItemComponent;



// WEBPACK FOOTER //
// ./src/components/Memo/otherActions.tsx